// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICategorySpendLimitDto } from './ICategorySpendLimitDto';
import {
    ICategorySpendLimitDtoFromJSON,
    ICategorySpendLimitDtoFromJSONTyped,
    ICategorySpendLimitDtoToJSON,
    ICategorySpendLimitDtoToJSONTyped,
} from './ICategorySpendLimitDto';
import type { IPersonSpendLimitDto } from './IPersonSpendLimitDto';
import {
    IPersonSpendLimitDtoFromJSON,
    IPersonSpendLimitDtoFromJSONTyped,
    IPersonSpendLimitDtoToJSON,
    IPersonSpendLimitDtoToJSONTyped,
} from './IPersonSpendLimitDto';

/**
 * 
 * @export
 * @interface IPolicySpendLimitsDto
 */
export interface IPolicySpendLimitsDto {
    /**
     * 
     * @type {number}
     * @memberof IPolicySpendLimitsDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicySpendLimitsDto
     */
    policy_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPolicySpendLimitsDto
     */
    spend_period_type?: IPolicySpendLimitsDtoSpendPeriodTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IPolicySpendLimitsDto
     */
    commuter_limit_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicySpendLimitsDto
     */
    election_limit_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicySpendLimitsDto
     */
    rollover_limit_amount?: number;
    /**
     * 
     * @type {Array<IPersonSpendLimitDto>}
     * @memberof IPolicySpendLimitsDto
     */
    person_spend_limits?: Array<IPersonSpendLimitDto>;
    /**
     * 
     * @type {Array<ICategorySpendLimitDto>}
     * @memberof IPolicySpendLimitsDto
     */
    category_spend_limits?: Array<ICategorySpendLimitDto>;
}

/**
* @export
* @enum {string}
*/
export enum IPolicySpendLimitsDtoSpendPeriodTypeEnum {
    UNLIMITED = 'UNLIMITED',
    MONTHLY = 'MONTHLY',
    PLAN_YEAR = 'PLAN_YEAR'
}


/**
 * Check if a given object implements the IPolicySpendLimitsDto interface.
 */
export function instanceOfIPolicySpendLimitsDto(value: object): value is IPolicySpendLimitsDto {
    return true;
}

export function IPolicySpendLimitsDtoFromJSON(json: any): IPolicySpendLimitsDto {
    return IPolicySpendLimitsDtoFromJSONTyped(json, false);
}

export function IPolicySpendLimitsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPolicySpendLimitsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'policy_id': json['policy_id'] == null ? undefined : json['policy_id'],
        'spend_period_type': json['spend_period_type'] == null ? undefined : json['spend_period_type'],
        'commuter_limit_amount': json['commuter_limit_amount'] == null ? undefined : json['commuter_limit_amount'],
        'election_limit_amount': json['election_limit_amount'] == null ? undefined : json['election_limit_amount'],
        'rollover_limit_amount': json['rollover_limit_amount'] == null ? undefined : json['rollover_limit_amount'],
        'person_spend_limits': json['person_spend_limits'] == null ? undefined : ((json['person_spend_limits'] as Array<any>).map(IPersonSpendLimitDtoFromJSON)),
        'category_spend_limits': json['category_spend_limits'] == null ? undefined : ((json['category_spend_limits'] as Array<any>).map(ICategorySpendLimitDtoFromJSON)),
    };
}

export function IPolicySpendLimitsDtoToJSON(json: any): IPolicySpendLimitsDto {
    return IPolicySpendLimitsDtoToJSONTyped(json, false);
}

export function IPolicySpendLimitsDtoToJSONTyped(value?: IPolicySpendLimitsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['account_id'],
        'policy_id': value['policy_id'],
        'spend_period_type': value['spend_period_type'],
        'commuter_limit_amount': value['commuter_limit_amount'],
        'election_limit_amount': value['election_limit_amount'],
        'rollover_limit_amount': value['rollover_limit_amount'],
        'person_spend_limits': value['person_spend_limits'] == null ? undefined : ((value['person_spend_limits'] as Array<any>).map(IPersonSpendLimitDtoToJSON)),
        'category_spend_limits': value['category_spend_limits'] == null ? undefined : ((value['category_spend_limits'] as Array<any>).map(ICategorySpendLimitDtoToJSON)),
    };
}

